import { render, staticRenderFns } from "./BasketDropDown.vue?vue&type=template&id=a8c2e8fc&scoped=true&"
import script from "./BasketDropDown.vue?vue&type=script&lang=js&"
export * from "./BasketDropDown.vue?vue&type=script&lang=js&"
import style0 from "./BasketDropDown.vue?vue&type=style&index=0&id=a8c2e8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c2e8fc",
  null
  
)

export default component.exports